import { AddToInventoryFormState, AddToInventoryItemFormState } from '../index'
import { compareCost, CostComparison } from 'views/helpers/utils'

export type SetUnexpectedCost = ( key: number, flag: CostComparison ) => void

export function checkForUnexpectedCost( item: AddToInventoryItemFormState, storePartCost: number, setUnexpectedCost: SetUnexpectedCost ) {
	const floatCost = parseFloat( item.cost )
	let validation: { isInvalid: boolean, error?: string } = { isInvalid: false }
	let comparison: CostComparison = 'normal'

	if ( Number.isFinite( floatCost ) ) {
		comparison = compareCost( floatCost, storePartCost )

		if ( comparison === 'high' ) {
			validation = {
				isInvalid: true,
				error: 'High price',
			}
		} else if ( comparison === 'low' ) {
			validation = {
				isInvalid: true,
				error: 'Low price',
			}
		}
	}

	setUnexpectedCost( item.key, comparison )
	return validation
}

export function validateItem( itemState: AddToInventoryItemFormState ) {
	const newItemState = {
		...itemState,
	}
	let isInvalid = false

	if ( !itemState.item ) {
		newItemState.validation.item = {
			isInvalid: true,
			error: 'Item is required',
		}
		isInvalid = true
	} else {
		newItemState.validation.item = { isInvalid: false }
	}

	if ( itemState.quantity === '' || isNaN( parseInt( itemState.quantity, 10 ) ) ) {
		newItemState.validation.quantity = {
			isInvalid: true,
			error: 'Quantity is required',
		}
		isInvalid = true
	} else {
		newItemState.validation.quantity = { isInvalid: false }
	}

	if ( itemState.cost === '' || isNaN( parseFloat( itemState.cost ) ) ) {
		newItemState.validation.cost = {
			isInvalid: true,
			error: 'Cost is required',
		}
		isInvalid = true
	} else if ( parseFloat( itemState.cost ) <= 0 ) {
		newItemState.validation.cost = {
			isInvalid: true,
			error: 'Cost must be more than $0',
		}
		isInvalid = true
	} else {
		newItemState.validation.cost = { isInvalid: false }
	}

	return {
		isInvalid,
		newItemState,
	}
}

export function validateItems( items: AddToInventoryItemFormState[] ) {
	let isInvalid = false
	const newItems: AddToInventoryItemFormState[] = []

	items.forEach( ( itemState ) => {
		const { newItemState, isInvalid: isItemInvalid } = validateItem( itemState )
		newItems.push( newItemState )
		if ( isItemInvalid ) {
			isInvalid = true
		}
	} )

	return {
		isInvalid,
		newItems,
	}
}

export function validateFormFields( formState: AddToInventoryFormState ) {
	const newFormState = {
		...formState,
	}
	let isInvalid = false

	if ( !formState.inventoryLocation ) {
		newFormState.validation.inventoryLocation = {
			isInvalid: true,
			error: 'Store is required',
		}

		isInvalid = true
	} else {
		newFormState.validation.inventoryLocation = { isInvalid: false }
	}

	if ( !formState.reason ) {
		newFormState.validation.reason = {
			isInvalid: true,
			error: 'Reason is required',
		}
		isInvalid = true
	} else {
		newFormState.validation.reason = { isInvalid: false }
	}

	return {
		isInvalid,
		newFormState
	}
}

export function validateForm( formState: AddToInventoryFormState, formItems: AddToInventoryItemFormState[] ) {
	const { newFormState, isInvalid: isFormInvalid } = validateFormFields( formState )
	const { newItems, isInvalid: isItemInvalid } = validateItems( formItems )
	let isItemEmpty = false
	if ( formItems.length === 0 ) {
		newFormState.validation.items = {
			isInvalid: true,
			error: 'You must select at least one item',
		}
		isItemEmpty = true
	} else {
		newFormState.validation.items = { isInvalid: false }
	}

	return {
		newFormState,
		newItems,
		isInvalid: isFormInvalid || isItemInvalid || isItemEmpty
	}
}

export default validateForm
